import AnchorItem from './AnchorItem';

export default AnchorItem;
